import React, { useState } from "react";
import {
  useSelector,
  useDispatch,
} from "react-redux";
import ErrorOverlay from "../../UserComponents/overlays/ErrorOverlay.js";
import PenaltySettingsModal from "../settingPenaltyDescription/components/PenaltySettingsModal";
import Entypo from "@mui/icons-material/ArrowBack"; 
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import DescriptionIcon from '@mui/icons-material/Description';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ExposureIcon from '@mui/icons-material/Exposure';
import "./settings.css"; 
import UserSidebar from "../../../components/userSiderbar/userSidebar.jsx";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

{/* <button className="settings-btn">
  <div className="icon-circle-settings">
    <DescriptionIcon fontSize="small" className="icon-settings" />
  </div>
  <div className="text-container-settings">
    <p className="btn-txt-settings">ADDITIONAL TURNOVER DESCRIPTIONS</p>
  </div>
  <ChevronRightIcon className="chevron-icon" />
</button> */}


const Settings = (props) => {
  const dispatch = useDispatch();
  const operatorTeam = useSelector((state) => state.team.selectedTeam);

  const [error, setError] = useState(null);
  const [penaltyModalVisible, setPenaltyModalVisible] = useState(false);
  const [selectedRule, setSelectedRule] = useState(null);

  return (
    <div className="settings-container">
      <UserSidebar />
      <ErrorOverlay
        onBackdropPress={() => setError(null)}
        visible={!!error}
        error={error}
      />
      <div className="settings-header">
        {/* <h1 className="header-txt-team-settings">SETTINGS</h1> */}
      </div>

      <div className="settings-btn-container">
        <button
          onClick={() => props.history.push("/teamrules")}
          className="settings-btn"
        >
          <div className="icon-circle-settings">
            <DensitySmallIcon fontSize="small" className="icon-settings" />
          </div>
          <div className="text-container-settings">
            <p className="btn-txt-settings">Game Rules</p>
            <p className="name-txt-settings">
              Current Default:{" "}
              <span>
                {selectedRule
                  ? selectedRule.ruleName
                  : operatorTeam?.teamId?.gameRules?.ruleName || "N/A"}
              </span>
            </p>
          </div>
          <ChevronRightIcon className="chevron-icon" />
        </button>

        <button
          onClick={() => props.history.push("/settingTurnoverDescription")}
          className="settings-btn"
        >
          <div className="icon-circle-settings">
          <DescriptionIcon fontSize="small" className="icon-settings" />
          </div>
          <p className="btn-txt-settings">ADDITIONAL TURNOVER DESCRIPTIONS</p>
           <ChevronRightIcon className="chevron-icon" />
        </button>

        <button
          onClick={() => setPenaltyModalVisible(true)}
          className="settings-btn"
        >
          <div className="icon-circle-settings">
          <AccessTimeIcon fontSize="small" className="icon-settings" />
          </div>
          <p className="btn-txt-settings">PENALTY TIME & DESCRIPTIONS</p>
        </button>

        <button
          onClick={() => props.history.push("/settingsratings")}
          className="settings-btn"
        >
          <div className="icon-circle-settings">
          <ExposureIcon fontSize="small" className="icon-settings" />
          </div>
          <p className="btn-txt-settings">+/- Ratings</p>
          <ChevronRightIcon className="chevron-icon" />
        </button>
      </div>
      <PenaltySettingsModal
        onBackdropPress={() => setPenaltyModalVisible(false)}
        visible={penaltyModalVisible}
        navigation={props.history}
      />
    </div>
    
  );
};

export default Settings;
